class WorkflowStepWarningModalController {
    constructor() {
        // this.companyId = this.resolve.companyId;
        // this.clientOrBuId = this.resolve.clientOrBuId;
        // this.stepName = this.resolve.stepName;
        // this.message = this.resolve.message;
        // this.context = this.resolve.context;
    }
    $onInit() {
        this.companyId = this.resolve.companyId;
        this.clientOrBuId = this.resolve.clientOrBuId;
        this.stepName = this.resolve.stepName;
        this.message = this.resolve.message;
        this.context = this.resolve.context;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './workflow-step-warning-modal.html';
import * as TEMPLATE from 'raw-loader!./workflow-step-warning-modal.html';
export const WorkflowStepWarningModalComponent = {
    selector: 'workflowStepWarningModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: WorkflowStepWarningModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/workflowStepWarningModal/workflow-step-warning-modal.html'
    }
};
//# sourceMappingURL=workflow-step-warning-modal.component.js.map